import service from '@/plugins/service'

const base = '/device/linkage'

export const getLinkages = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addLinkage = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const getDetails = id => {
  return service({
    url: `${base}`,
    params: {
      id
    }
  })
}

export const updateLinkage = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const deleteLinkage = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}